<template>
	<div class="course">
        <!-- left panel -->
        <el-col :span="5" class="course-categories">
           <div class="course-category" 
                :class="courseCategory === 0 ? 'onSetttng' : ''" @click="setCategory(0)">
                必修課
            </div>
            <div class="course-category" 
                :class="courseCategory === 1 ? 'onSetttng' : ''" @click="setCategory(1)">
                選修課
            </div>
        </el-col>
        <!-- right panel -->
        <el-col :span="19">
            <div class="course-title">
                <div style="float: left;">
                    <div>
                        {{ categoryTitle }} 
                    </div>
                </div>
                <div style="display: inline-block;">
                    <el-cascader placeholder="" class="menu-select"
							v-model="selectedDepId"
							:show-all-levels="false"
    						:options="actualDepsOptions"
							@change="handleActualDepSelect">
			        </el-cascader>
                </div>
            </div>
            <div class="course-content">
                <el-row v-if="courseCategory === 0">
                    <CourseType :key="refreshKey" :courseType="1" :selectedDepId="selectedDepId"></CourseType>
                </el-row>
                <el-row v-else-if="courseCategory === 1">
                    <CourseType :key="refreshKey" :courseType="0" :selectedDepId="selectedDepId"></CourseType>
                </el-row>
            </div>
        </el-col>
    </div>
</template>
<script>
import { DepartmentModel } from '@/common/js/data';
import CourseType from './CourseType';
export default {
    name: 'Course',
    components: {
        CourseType,
    },
    data() {
        return {
            refreshKey: 0,
            courseCategory: -1,
            categoryTitle: "",
            selectedDepId: null,
            actualDepsOptions: [],
        }
    },
    watch: {
        '$store.state.userInfoReady': {
            immediate: true,
            handler(val) {
                if (val) {
                    this.initial();
                }
            }
        }
    },
    created() {
        this.$store.state.nowStatus = 14;
    },
    methods: {
        async initial() {
            let departmentModel = new DepartmentModel();
            this.actualDepsOptions = await departmentModel.getActualDepsOptions();
            if (this.$store.state.course.listStatus.depid && this.$store.state.course.listStatus.actual_depid) {
                this.selectedDepId = [this.$store.state.course.listStatus.depid,
                 this.$store.state.course.listStatus.actual_depid]
            } else if (this.$store.state.isSystemAdminMode) {
                this.selectedDepId = [this.actualDepsOptions[0].value, this.actualDepsOptions[0].children[0].value]
            } else {
                this.selectedDepId = [this.$store.state.userDepId, this.$store.state.userActualDepId];
            }

            if (this.$store.state.course.listStatus.type) {
                this.setCategory(this.$store.state.course.listStatus.type);  
            } else {
                this.setCategory(0);  
            }
            
        },
        setCategory: function(index) {
            this.$store.state.course.listStatus.type = index;
            this.courseCategory = index;
            this.refreshKey += 1;
            switch (index) {
                case 0:
                    this.categoryTitle = "必修課";
                    break;
                case 1:
                    this.categoryTitle = "選修課";
                    break;
                default:
                    break;
            }
        },
        handleActualDepSelect: function(key) {
            this.$store.state.course.listStatus.depid = key[0];
            this.$store.state.course.listStatus.actual_depid = key[1];
        },
    },
}
</script>
<style lang="scss">
$border-color: #D5D5D4;
$border-color2: #EEEEEE;
.course {
	margin-top : 22px;

    .course-categories {
		background-color: white;
		border: $border-color2 1px solid;
    	height: 250px;
    	float: left;

        .course-category {
            line-height: 24px;
            display: inline-block;
            margin-left: 15px;	
            margin-top: 20px;
            padding-bottom: 15px;	
            border-bottom: 1px solid $border-color;
            width: 80%;
            font-size: 16px;
            color: #515151;
            cursor: pointer;
        }

        .onSetttng {
            color: #1D2327;
            font-weight: 500;
        }
    }

    .course-title {
        margin-left: 30px;
        color: #3C3B38;
        font-size: 24px;
        font-weight: 500;
        height: 48px;
        line-height: 48px;
        
        
        .menu-select {
			display: block;
			float: left;
			max-width: 18vw;
			margin-left: 20px;
			text-align: center;

            .el-cascader-menus {
                margin-top: 0px;
            }

			.el-cascader__label{
				margin-top: 9px;
			}

			.el-input__inner{
				border-color: #B6B6B6;
				background-color: white;
				border-radius: 2px;
				font-size: 14px;
				font-weight: 500;
				color: #222;
				line-height: 24px;
				margin-top: 9px;	
			}
	
			.el-input__icon{
				width: 40px;
				margin-top: 4px;
				color: #626874;
			}
		
			.el-input__suffix {
				&:before {
					content: '';
					position: absolute;
					left: 0;
					height: 32px;
					width: 1px;
					background-color: rgba(151, 151, 151, .35);
					margin-top: 7px;
				}
			}

			.el-icon-arrow-up {
				&:before {
					color: #a7a7a7;
					content: '\25B2';
				}
			}
		}
    }

    .course-content {
        margin-left: 20px;
    }
}
</style>


// WEBPACK FOOTER //
// Course.vue?453cdae8